@import '../styles/_vars.css';

.testimonials {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  min-height: 250px;
  text-align: center;
  padding-bottom: 4em;
  padding-top: 4em;
}

.content h2 {
  font-size: 2.4em;
  margin-bottom: 0.9em;
}

.content h3 {
  font-size: 1.8em;
  margin-bottom: .2em;
}

.cta {
  margin-top: 2em;
}
